/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { columns } from './utils/list_data';
import { formatDate } from 'src/utils/dates';
import { useHistory } from 'react-router-dom';
import { usersAPI } from 'src/api/modules/users';
import notice from 'src/common/components/Notice';
import React, { useState, useEffect } from 'react';
import DeleteReportModal from './DeleteReportModal';
import { usePagination } from 'src/hooks/usePagination';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';

const Reports = () => {
	const history = useHistory();
	const [miembros, setMiembros] = useState([]);
	const [modalDelete, setModalDelate] = useState(false);
	const [IdUser, setIdUser] = useState();
	const [disableBoton, setDisableBoton] = useState(false);
	const [disableExcel, setDisableExcel] = useState(true);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();

	const {
		pagination,
		handlePagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
	} = usePagination();

	useEffect(() => {
		getDataFromApi();
		if (
			systemLevelRole !== 'ADMINISTRADOR GENERAL' &&
			systemLevelRole !== 'OPERADOR DE SEGURIDAD'
		) {
			setDisableBoton(true);
		}
	}, [systemLevelRole, pagination, currentPage]);

	const getDataFromApi = () => {
		setMiembros([]);
		usersAPI
			.get(
				`todos?conorganos=false&numeroDePagina=${currentPage}&registrosPorPagina=${pagination}`
			)
			.then((response) => {
				if (response.usuarios && response.usuarios.length > 0) {
					let data = [];
					response.usuarios.forEach((item) => {
						data.push({
							...item,
							profile:
								item.id_perfil !== undefined
									? item.perfilNombre
									: 'Sin Perfil',
						});
					});

					setMiembros(data);
					setDisableExcel(false);
					setTotalResults(response.totalRegistros);
				}
			})
			.catch((e) => notice('Error al cargar los usuarios'));
	};

	const onEye = (id) => history.push(`/administracion-de-usuarios/usuario/${id}`);

	const onDelete = () => {
		usersAPI
			.delete(IdUser)
			.then(() => {
				notice('Usuario eliminado', 'success');
				getDataFromApi();
			})
			.catch((e) => notice('Ha ocurrido un error con su petición'));
		setModalDelate(false);
		setIdUser();
	};

	const onRepeat = (user) => {
		let newUser = {
			...user,
			estatus: user.estatus === 'Activo' ? 'I' : 'A',
		};

		delete newUser.fechaCreacion;
		delete newUser.fechaUltimoAcceso;
		delete newUser.usuario;
		delete newUser.organos;
		delete newUser.correos;
		delete newUser.profile;

		usersAPI
			.put(newUser.id, newUser)
			.then((res) => {
				if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500') {
					notice(JSON.parse(JSON.stringify(res.mensaje)));
				} else {
					notice('Estado cambiado correctamente', 'success');
					getDataFromApi();
				}
			})
			.catch((e) => {
				notice('Ha ocurrido un error con su petición');
			});
	};

	const onModalDelete = (id) => {
		setModalDelate(true);
		setIdUser(id);
	};

	return (
		<PageLayout>
			<FullTable
				title="Reportes"
				items={miembros}
				count={miembros.length}
				columns={columns(onEye, onModalDelete, onRepeat, disableBoton)}
				CVSFileName={`Reportes_${formatDate('P p')}.csv`}
				disabledCSV={disableExcel}
				ExcelFileName={`Reportes_${formatDate('P p')}.xls`}
				disabledExcel={disableExcel}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			<DeleteReportModal
				open={modalDelete}
				setClose={setModalDelate}
				onDelete={onDelete}
			/>
		</PageLayout>
	);
};

export default Reports;
